// extracted by mini-css-extract-plugin
module.exports = {"actionbutton":"TopicsEditFormComponent_actionbutton__27I73","addcriterion":"TopicsEditFormComponent_addcriterion__2cSh3"};